import Table from "cli-table3";
import chalk from "chalk";
import { log } from "./log";
import type { ApiAlertsResponse } from "@/pages/api/alerts";
import { getBaseUrl } from "@/config";

export async function displayAlerts(alertsData: ApiAlertsResponse) {
  if (!alertsData.ok) {
    log.error(alertsData.error);
    process.exit(1);
  }

  try {
    if (!alertsData.alerts || !alertsData.alerts.length) {
      log.info("\nNo alerts found");
      return;
    }

    const table = new Table({
      head: ["Date", "Title", "Source", "Rotation", "Payload"].map((h) =>
        chalk.cyan(h),
      ),
      colWidths: [12, 35, 15, 20, 40],
      wordWrap: true,
    });

    // Display routing prompt above table
    log.info("\nCurrent routing prompt:");
    log.info(chalk.dim(alertsData.routingPrompt));
    log.info(""); // empty line for better spacing

    for (const alert of alertsData.alerts) {
      const date = new Date(alert.created || "").toISOString().split("T")[0];
      const payload = JSON.stringify(alert.payload || {});
      const truncatedPayload =
        payload.length > 37 ? payload.slice(0, 37) + "..." : payload;

      table.push([
        date,
        alert.title,
        alert.source || "-",
        alert.rotation?.name || "-",
        truncatedPayload,
      ]);
    }

    console.log(table.toString());
    log.info(`\nTotal alerts: ${alertsData.alerts.length}`);
  } catch (error) {
    log.error("Failed to display alerts");
    console.error(error);
    process.exit(1);
  }
}

export async function fetchAlerts(token: string) {
  try {
    // Fetch alerts from Astro endpoint
    const alertsResponse = await fetch(
      `${getBaseUrl({ prodUrl: !process.env.BEEPS_DEVELOPMENT })}/api/alerts`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!alertsResponse.ok) {
      throw new Error(`Failed to fetch alerts: ${alertsResponse.statusText}`);
    }

    const alertsData = (await alertsResponse.json()) as ApiAlertsResponse;
    return displayAlerts(alertsData);
  } catch (error) {
    log.error("Failed to fetch alerts");
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error(error);
    }
    process.exit(1);
  }
}
